import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { HS_USER_KEYS } from 'src/constants/userSetting';
import { createAsync } from 'src/utils/asyncModel';
const getHubspotTokenAsync = createAsync(() => {
  return async function getHubspotToken(options) {
    var _resp$response, _resp$response2;
    const resp = await api.Hubspot.getHubspotToken(options);
    localStorage.setItem(HS_USER_KEYS.email, resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.email);
    localStorage.setItem(HS_USER_KEYS.token, resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.token);
    return resp;
  };
});
const HubspotUserInfo = types.model({
  email: types.maybeNull(types.string),
  token: types.maybeNull(types.string)
});
const HubspotStore = types.model('HubspotStore', {
  getHubspotTokenAsync,
  hubspotUserInfo: types.optional(HubspotUserInfo, {
    email: null,
    token: null
  })
}).actions(store => ({
  setHubspotUserInfo(data) {
    try {
      store.hubspotUserInfo.email = data.email;
      store.hubspotUserInfo.token = data.token;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));
export const hubspot = types.optional(HubspotStore, {});